/*
 * @Description: 
 * @Version: 2.0
 * @Autor: YGQ
 * @Date: 2024-07-26 11:11:54
 * @LastEditors: YGQ
 * @LastEditTime: 2024-08-01 16:11:55
 */
import localForage from 'localforage'

function setForageItem (key, value) {
  if (!value) return false
  return localForage.setItem(key, JSON.parse(JSON.stringify(value)))
}

function getForageItem (key, value) {
  return localForage.getItem(key)
}


const install = (app) => {
  app.config.globalProperties.$setForageItem = setForageItem
  app.config.globalProperties.$getForageItem = getForageItem
};

export default {
  install,
};

